if (!customElements.get('custom-carousel')) {
  customElements.define('custom-carousel', class extends HTMLElement {
    constructor() {
      super();
      this.slideContainer = this;

      this.slidesPerView = +this.dataset.slidesPerView || 4.3;
      this.spaceBetween = +this.dataset.spaceBetween || 10;
      this.slidesPerViewSmallDesktop = +this.dataset.slidesPerViewSmallDesktop || this.slidesPerView;
      this.slidesPerViewTablet = +this.dataset.slidesPerViewTablet || this.slidesPerViewSmallDesktop || 3.2;
      this.slidesPerViewMobile = +this.dataset.slidesPerViewMobile || 2.2;
      this.spaceBetweenMobile = +this.dataset.spaceBetweenMobile || 10;

      this.loop = this.hasAttribute('data-loop') || false;

      this.enableScrollbar = this.hasAttribute('data-enable-scrollbar') || false;
    }

    connectedCallback() {
      this.initCarousel();
    }

    initCarousel() {
      const options ={
        slidesPerView: this.slidesPerViewMobile,
        spaceBetween: this.spaceBetweenMobile,
        loop: this.loop,
        breakpoints: {
          749: {
            slidesPerView: this.slidesPerViewTablet,
            spaceBetween: this.spaceBetween,
          },
          989: {
            slidesPerView: this.slidesPerViewSmallDesktop,
            spaceBetween: this.spaceBetween,
          },
          1280: {
            slidesPerView: this.slidesPerView,
            spaceBetween: this.spaceBetween,
          },
        },
        navigation:  {
          nextEl: '.swiper-btn--next',
          prevEl: '.swiper-btn--prev',
        },
        ...(this.enableScrollbar && {
          scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
          },
        }),
      }

      this.carousel = new Swiper(this.slideContainer, options);
    }

    disconnectedCallback() {
      if (this.carousel && typeof this.carousel.destroy === 'function') {
        this.carousel.destroy();
      }
    }
  });
}